import { IMenuListLink } from '../../molecules/menu-list/menu-list';
import { IAdditiveFilterModel } from '../../organisms/additive-filter/additive-filter';
import t from '../../../labels/labelling-utils';
import { IMatch, MatchStatusType } from '../../../typings/match';
import { isEnded, isLive, isPreMatch } from '../../../utils/match-status';

import { ICompetition, IMatchRound } from './football-live-score';

export const filterDays: IMenuListLink[] = [
  { label: t('previous-day-filter') },
  { label: t('current-day-filter') },
  { label: t('next-day-filter') },
];

export const statusFilterModel: IAdditiveFilterModel[] = [
  { name: t('filter-all') },
  { name: t('tennis.match.status.live') },
  { name: t('filter-ended') },
  { name: t('tennis.match.status.scheduled') },
];

export const getMatchListFiltered = (filteredList: ICompetition[], selectedStatusIndex: number): IMatch[][][] =>
  filteredList.map((competition: ICompetition) => {
    const { matchRoundList } = competition;
    return matchRoundList.length > 0
      ? matchRoundList.map((matchRound: IMatchRound) => {
          const matchList: IMatch[] = matchRound.matchDayList[0].matchList ?? [];
          return filterMatchList(matchList, selectedStatusIndex);
        })
      : [];
  });

export const filterMatchList = (matchList: IMatch[], selectedStatusIndex: number) => {
  return matchList.filter((match: IMatch) => {
    switch (selectedStatusIndex) {
      case 1:
        return isLive(match.status);
      case 2:
        return isEnded(match.status);
      case 3:
        return isPreMatch(match.status);
      default:
        return Boolean(match);
    }
  });
};

export const handleAutoScroll = (selectedStatusIndex: number, wrapper: HTMLDivElement | null) => {
  if (!wrapper) {
    return;
  }
  const OFFSET_TOP = 64 + 20;
  const TABS_HEIGHT = 62;
  const offset = window.innerWidth < 1024 ? OFFSET_TOP : TABS_HEIGHT + OFFSET_TOP;

  const checkStatus = (child: HTMLDivElement, checkFn: Function) => {
    return checkFn((child.getAttribute('data-status') ?? '') as MatchStatusType);
  };

  const autoScroll = () => {
    const rowsWithStatus = Array.from(wrapper.querySelectorAll<HTMLDivElement>('[data-status]'));
    const firstCompetition = wrapper.querySelector<HTMLDivElement>('[data-competition-index]');
    let firstRow = wrapper.querySelector<HTMLDivElement>('[data-status]');

    if (firstRow && (selectedStatusIndex === 0 || selectedStatusIndex === 1)) {
      firstRow = rowsWithStatus.find((child) => checkStatus(child, isLive)) ?? firstRow;
    }
    if (firstRow && selectedStatusIndex === 2) {
      firstRow = rowsWithStatus.find((child) => checkStatus(child, isEnded)) ?? firstRow;
    }
    if (firstRow && selectedStatusIndex === 3) {
      firstRow = rowsWithStatus.find((child) => checkStatus(child, isPreMatch)) ?? firstRow;
    }

    const competition = firstRow?.parentElement || firstCompetition?.parentElement;

    if (competition) {
      const competitionTop = competition.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: competitionTop, behavior: 'smooth' });
    }
  };

  setTimeout(autoScroll, 0);
};
